import { AthosFetcher } from '../classes/athos-fetcher'
import { normaliseRecommendations } from '../helpers/normalisers'
import { generateAthosProvider } from './provider'
import { getPersonalizationOrigin } from '../athos-utils'

export class AthosCustomProducts extends AthosFetcher {
  generateOrigin() {
    return getPersonalizationOrigin(this.params.siteID)
  }

  generateURL() {
    return super.generateURL('/recommend')
  }

  updateParams(options = {}) {
    const { sku, skus, tags, limit, profile } = options

    if (sku) this.params.set('product', sku)
    if (tags) this.params.set('tags', tags)
    if (limit) this.params.set('limits', limit)
    if (profile) this.params.set('tags', profile)

    if (skus) this.params.set('lastViewed', skus.join(','))

    this.params.setCartItems()
    this.params.setShopperID()

    super.updateParams()
  }
}

export const AthosCustomProductsProvider = generateAthosProvider(
  AthosCustomProducts,
  (_results) => {
    const profiles = Array.isArray(_results) ? _results : [_results].filter(Boolean)
    const results = profiles.map((res) => normaliseRecommendations(res)).flat()
    const [firstProfile] = profiles
    return {
      results,
      responseId: firstProfile?.responseId,
      profile: firstProfile?.profile
    }
  }
)
